import * as S from "./styles";
import { useScheduleDetail } from "./useScheduleDetail";
import { StepButtonScheduleDetail } from "../../Atoms/StepButtonScheduleDetail";
import "react-vertical-timeline-component/style.min.css";
import { FormScheduleDetail } from "../../Molecules/FormScheduleDetail";
import { HistoryModifySchedule } from "../HistoryModifySchedule";
import { InvoicesSchedule } from "../../Molecules/InvoicesSchedule";

export const ScheduleDetailTemplate = () => {
  const { setStep, step } = useScheduleDetail();

  return (
    <S.Container>
      <S.WrapperStepButton>
        <StepButtonScheduleDetail getFormNumber={setStep} />
      </S.WrapperStepButton>

      <S.Wrapper>
        {step === 1 && <FormScheduleDetail />}
        {step === 2 && <InvoicesSchedule />}
        {step === 3 && <HistoryModifySchedule />}
      </S.Wrapper>
    </S.Container>
  );
};
